export const safeParseJson = <T = unknown>(jsonStr: string): T | null => {
  try {
    return JSON.parse(jsonStr) as T
  } catch {
    return null
  }
}

const map = new Map<string, string>()

export const generateUUID = (): string => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  if (map.has(uuid)) {
    return generateUUID()
  } else {
    map.set(uuid, uuid)
    return uuid
  }
}

export function isFunction(func: unknown) {
  return typeof func === 'function'
}
